import React from 'react';

import { ReportInspectedProductsByMisstatementView } from './ReportInspectedProductsByMisstatementView';

export const ReportInspectedProductsByMisstatementIView: React.FC = () => {
  return <ReportInspectedProductsByMisstatementView group="I" />;
};
